import { Grid } from '@mui/material';
import { SideBox } from './side_box.component';
import { TopHeaderBar } from '../../common/components/top_header_bar.component';
import { RightMapSectionLandingPage } from './right_map_section_landing_page.component';
export const MainLandingPage = () => {
  return (
    <>
      <TopHeaderBar />
      <Grid container spacing={2} sx={{ background: 'black', height: 'calc(100vh - 70px)', mt: 0 }}>
        <Grid item xs={12} md={4} lg={4} sx={{ background: 'black' }}>
          <SideBox />
        </Grid>
        <RightMapSectionLandingPage />
      </Grid>
    </>
  );
};
